import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FiHelpCircle, FiPlus } from 'react-icons/fi';
import { IoHelpCircleOutline } from "react-icons/io5";
import InputBox from '../../../Components/Input';
import SelectDropdown from '../../../Components/InputSelect';
import Loader from '../../../Components/Loader';
import ModalDailog from '../../../Components/Modal';
import Tooltip from '../../../Components/Tooltip';
import useMyAgencyData from '../../../hooks/useMyAgencyData';
import { API_ENDPOINTS } from "../../../utils/api";
import createAxiosInstance from "../../../utils/axiosInstance";
import { formatToUSD } from '../../../utils/formatters';
import { needReasonOptions } from '../../../utils/helper';

const CreateNewNeed = ({ updateFeed }: { updateFeed?: () => void }) => {
  const axiosInstance = createAxiosInstance();
  const myShelter = useMyAgencyData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFeesModalOpen, setIsFeesModalOpen] = useState(false);
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [isLoding, setIsLoding] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    assessments: [{
      amount: null,
      description: "",
      fee: null,
      needReason: "",
      numberOfBednight: null,
      originalAmount: null,
      referenceId: ""
    }],
    caseReferenceId: "",
    groupId: []
  });

  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    reset
  } = useForm<{
    assessments: {
      amount: number | null;
      description: string;
      fee: number | null;
      needReason: string;
      numberOfBednight: number | null;
      originalAmount: number | null;
      referenceId: string;
    }[];
    caseReferenceId: string;
    grouoId: string[]
  }>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
  });

  const watchOriginalAmount = watch("assessments.0.originalAmount");
  const watchReferenceId = watch("assessments.0.referenceId");
  const watchNeedReason = watch("assessments.0.needReason");

  useEffect(() => {
    setValue("caseReferenceId", watchReferenceId);
  }, [watchReferenceId]);

  useEffect(() => {
    setValue("assessments.0.description", "");
  }, [watchNeedReason]);

  useEffect(() => {
    if (watchOriginalAmount && myShelter) {
      const fees = myShelter.details.fee ?? 0;
      setValue("assessments.0.fee", watchOriginalAmount * (fees / 100));
      setValue(
        "assessments.0.amount",
        (watchOriginalAmount * (fees / 100)) + (watchOriginalAmount * 1),
      );
    } else {
      setValue("assessments.0.fee", null);
      setValue("assessments.0.amount", null);
    }
  }, [watchOriginalAmount, myShelter]);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  }

  const handleFeesModal = () => {
    setIsFeesModalOpen(true);
  }

  const closeModalOpen = () => {
    reset(defaultValues);
    setIsModalOpen(false);
  }

  const closeFeessModal = () => {
    setIsFeesModalOpen(false);
  }

  const closeModalView = () => {
    setIsModalOpenView(false);
  }

  const submitNeedHandler: SubmitHandler<any> = async () => {
    setIsModalOpenView(true);
  };

  const handlePreviewSubmit: SubmitHandler<any> = async (formData: any) => {
    try {
      setIsLoding(true);
      if (formData.caseReferenceId === "") {
        delete formData.caseReferenceId;
      }
      const closeRequest = await axiosInstance.post(API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS, formData);

      if (closeRequest.status === 200) {
        closeModalView();
        closeModalOpen();
        if (updateFeed)
          updateFeed();
      }
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };
  const tooltipText = `What is this?`;
  return (
    <>
      {isLoding && <Loader />}
      <button className="btn btn-primary bg-[#49907B] rounded-full" onClick={handleModalOpen}>
        <FiPlus size={20} /> Create an Alert
      </button>
      <ModalDailog isOpen={isModalOpen} handleSubmit={handleSubmit} closeRequest={submitNeedHandler} onClose={closeModalOpen} title="Create a New Donation Alert" backButton="Back" primaryButton='Create New Alert'>
        <div className="mb-6 flex items-center gap-3 justify-center">
          <label htmlFor="CostOfRoom" className='block text-md font-medium text-gray-500 w-40 text-end'>Cost of Room</label>
          <div className="w-6/12">
            <InputBox
              type="number"
              id='CostOfRoom'
              onKeyDown={(e: any) => {
                if (e.key === '-' || e.key === 'e') {
                  e.preventDefault();
                }
              }}
              {...register('assessments.0.originalAmount', {
                min: {
                  value: 0,
                  message: "Value must be greater than or equal to 0"
                },
                required: true,
              })}
            />
            {errors?.assessments?.[0]?.originalAmount?.type === "required" && (
              <label className="text-error">
                Please enter amount.
              </label>
            )}
            {errors?.assessments?.[0]?.originalAmount?.type === "min" && (
              <label className="text-error">
                Cost of Room must be greater than or equal to 0
              </label>
            )}
          </div>
        </div>
        <div className="mb-6 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='flex justify-end gap-1 items-center text-md font-medium text-gray-500 w-40 text-end'> <span className='cursor-pointer' onClick={handleFeesModal}><Tooltip text={tooltipText}><IoHelpCircleOutline size="24" className="text-error" /></Tooltip></span> Fees</label>
          <div className="w-6/12">
            {formatToUSD(getValues('assessments.0.fee') ?? undefined)}
          </div>
        </div>
        <div className="mb-6 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='block text-md font-medium text-gray-500 w-40 text-end'> Total Amount</label>
          <div className="w-6/12">
            {formatToUSD(getValues('assessments.0.amount') ?? undefined)}
          </div>
        </div>
        <div className="mb-6 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='block text-md font-medium text-gray-500 w-40 text-end'> Reason</label>
          <div className="w-6/12">
            <SelectDropdown
              options={needReasonOptions}
              name="assessments.0.needReason"
              placeholder="Choose an option"
              labelIcon={<FiHelpCircle />}
              value={watch("assessments.0.needReason")}
              register={register}
              setValue={setValue}
            />
            {errors?.assessments?.[0]?.needReason?.type === "required" && (
              <label className="text-error">
                This field is required.
              </label>
            )}
          </div>
        </div>
        {watch(`assessments.0.needReason`) == needReasonOptions[needReasonOptions.length - 1].value && (
          <div className="mb-6 flex items-center gap-3 justify-center">
            <label htmlFor="description" className='block text-md font-medium text-gray-500 w-40 text-end'>Description</label>
            <div className="w-6/12">
              <InputBox
                type="text"
                id='description'
                {...register("assessments.0.description", { required: true })}
              />
              {errors?.assessments?.[0]?.description?.type === "required" && (
                <label className="text-error">
                  This field is required.
                </label>
              )}
            </div>
          </div>
        )}
        <div className="mb-6 flex items-center gap-3 justify-center">
          <label htmlFor="NumberofBedNights" className='block text-md font-medium text-gray-500 w-40 text-end'>Number of Bed Nights</label>
          <div className="w-6/12">
            <InputBox
              type="number"
              id='NumberofBedNights'
              onKeyDown={(e: any) => {
                if (e.key === '-' || e.key === 'e' || e.key === '.') {
                  e.preventDefault();
                }
              }}
              {...register("assessments.0.numberOfBednight", { 
                min: {
                  value: 1,
                  message: "Value must be greater than or equal to 1"
                },
                required: true
              })}
            />
            {errors?.assessments?.[0]?.numberOfBednight?.type === "required" && (
              <label className="text-error">
                Please enter number of beds in numeric form.
              </label>
            )}
            {errors?.assessments?.[0]?.numberOfBednight?.type === "min" && (
              <label className="text-error">
                Number of Bed Nights must be greater than or equal to 1
              </label>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 justify-center">
          <label htmlFor="ReferenceId" className='block text-md font-medium text-gray-500 w-40 text-end'>Reference ID</label>
          <div className="w-6/12">
            <InputBox
              type="text"
              id='ReferenceId'
              {...register("assessments.0.referenceId")}
            />
          </div>
        </div>
      </ModalDailog>
      <ModalDailog isOpen={isFeesModalOpen} onClose={closeFeessModal} title="About fees" modalClassName="md:max-w-lg lg:max-w-lg" backButton="Close">
        <p className='text-sm 2xl:text-lg text-gray-600'>Payment processing fees are automatically calculated and added to the total amount requested to ensure that donations cover the full cost of the hotel room.</p>
        <p className='text-sm 2xl:text-lg text-gray-600 font-semibold mt-3'>Total Amount = Cost of Room + Fees</p>
      </ModalDailog>
      {/* onClick={handleSubmitModal} */}

      {/* view modal on submit handle */}
      <ModalDailog isOpen={isModalOpenView} handleSubmit={handleSubmit} closeRequest={handlePreviewSubmit} onClose={closeModalView} title="Create an Alert" backButton="Back" primaryButton='Create'>
        <div className="mb-8 flex items-center gap-3 justify-center">
          <label htmlFor="CostOfRoom" className='block text-md font-medium text-gray-500 w-40 text-end'>Cost of Room</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>{formatToUSD(watchOriginalAmount ?? undefined)}</span>
          </div>
        </div>
        <div className="mb-8 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='block text-md font-medium text-gray-500 w-40 text-end'>Fees</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>{formatToUSD(watch('assessments.0.fee') ?? undefined)}</span>
          </div>
        </div>
        <div className="mb-8 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='block text-md font-medium text-gray-500 w-40 text-end'> Total Amount</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>{formatToUSD(watch('assessments.0.amount') ?? undefined)}</span>
          </div>
        </div>
        <div className="mb-8 flex items-center gap-3 justify-center">
          <label htmlFor="whatFees" className='block text-md font-medium text-gray-500 w-40 text-end'> Reason</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>{watch('assessments.0.needReason')}</span>
          </div>
        </div>
        <div className="mb-8 flex items-center gap-3 justify-center">
          <label htmlFor="NumberofBedNights" className='block text-md font-medium text-gray-500 w-40 text-end'>Number of Bed Nights</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>{watch('assessments.0.numberOfBednight')}</span>
          </div>
        </div>
        <div className="flex items-center gap-3 justify-center">
          <label htmlFor="ReferenceId" className='block text-md font-medium text-gray-500 w-40 text-end'>Reference ID</label>
          <div className="w-6/12">
            <span className='text-gray-800 font-semibold'>#{watch('assessments.0.referenceId')}</span>
          </div>
        </div>
      </ModalDailog>
    </>
  )
}

export default CreateNewNeed